import React, { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  TABLE_DATA,
  TABLE_HEADERS,
  keyMapping,
} from "../../../../constants/SalesQuotationApprovalList";

import ROUTES_NAVIGATION from "../../../../routes/routes";
import ListPage from "../../Sales/Shared/ListPage";
import axiosInstance from "../../../services/api/API";
import Loader from "../../../customComponents/CustomLoader";

const PurchaseOrder = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [PurchaseOrderData,setPurchaseOrderData] = useState([])
  const [CountData,setCountData] = useState([])
 
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("authToken");
  const dealer_id = localStorage.getItem("dealer_id");
  const showroom_id = localStorage.getItem("showroom_id");
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);


  }
  console.log("Countdata",CountData);
  
   const topDataList = [
    { id: 1, title: "Total  Item In-Stock", value: Number(CountData?.totalitemstockinQty) },
    { id: 2, title: "Total Vehicle In-Stock", value:Number(CountData?.totalvehiclestockinQty)},
    { id: 3, title: "Total Pending Item In-Stock", value: (Number(CountData?.totalitemacceptedQty) +(Number(CountData?.totalvehicleacceptedQty) ))- (Number(CountData?.totalvehiclestockinQty)+Number(CountData?.totalitemstockinQty))},
    { id: 4, title: "Total Complete In-Stock", value: Number(CountData?.totalitemstockinQty) + Number(CountData?.totalvehiclestockinQty)  },
   
  ];
  const apiCallFunction = () =>{
    fetchPurchaseOrderList()
  }
  const handleAddNavigation = () => {
    navigate(ROUTES_NAVIGATION.ADDPURCHASEORDER)
  }

  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.PURCHASEORDERDETAILS}`, { state: { data: rowData } });
  }
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchPurchaseOrderList(newPage);
  };

  const fetchPurchaseOrderList = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/purchaseorder/list', {
        orderBy:"po_id desc",
        page,
        pageSize,
        dealer_id:dealer_id,
        showroom_id:showroom_id>0?showroom_id:null,
        searchText:searchQuery
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1 + page * pageSize
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      setCountData(response?.data?.data?.countdata)
      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

    
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setPurchaseOrderData(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
     
    } catch (error) {
      console.error('Error fetching product list:', error);
    }
    finally{
      setLoading(false)
    }
  };
  useEffect(() => {
    fetchPurchaseOrderList();
  }, []);
  const handleEdit = (rowData) =>{
    navigate(ROUTES_NAVIGATION.UPDATEPURCHASEORDER,{state:{rowData,isEdit:true}})

  }
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      apiCallFunction(0, 10,searchQuery); 
    }
  }

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
    <ListPage
    //   isButtonRequired={false}
    addButtonTitle = "Create New Order"
    isUploadButtonRequired={false}
      headerTopText="Logistics / Purchase Order"
      headerTitle="Purchase order"
      listTitle="Purchase Order List"
      topDetailsList={topDataList}
      tableData={PurchaseOrderData}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      totalPages={totalPages}
      totalRecords={totalRecords}
      currentPage={currentPage}
      onEdit={handleEdit}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      handleSearchChange={handleSearchChange}
      handleKeyPress={handleKeyPress} 
      handlePageChange={handlePageChange}
      apiCallFunction={apiCallFunction}
      handleOnAddButton={handleAddNavigation}
      handleViewButton={handleViewDetails}
     
      searchplaceholder= "Search by PO Type"
    />
    </div>
    )}
    </div>
  );
};

export default PurchaseOrder;
